import { base16, base32crockford } from '@scure/base';
import { Base64 } from 'js-base64';
export const xor = (arrayLeft, arrayRight) => {
    if (arrayLeft.byteLength !== arrayRight.byteLength) {
        throw new Error('Invalid array length');
    }
    const result = new Uint8Array(arrayRight.byteLength);
    for (let i = 0; i < arrayLeft.byteLength; i++) {
        if (arrayLeft[i] == undefined || arrayRight[i] == undefined) {
            throw new Error('Invalid arrays');
        }
        result[i] = arrayLeft[i] ^ arrayRight[i];
    }
    return result;
};
export const bufferXor = (arrayLeft, arrayRight) => {
    const leftView = new Uint8Array(arrayLeft);
    const rightView = new Uint8Array(arrayRight);
    return xor(leftView, rightView).buffer;
};
export const areEqual = (arrayLeft, arrayRight) => {
    if (arrayLeft.byteLength !== arrayRight.byteLength) {
        return false;
    }
    for (let i = 0; i < arrayLeft.byteLength; i++) {
        if (arrayLeft[i] !== arrayRight[i]) {
            return false;
        }
    }
    return true;
};
export const stringToArray = (str) => Base64.toUint8Array(Base64.toBase64(str)).buffer;
export const arrayToBase64 = (array, options) => Base64.fromUint8Array(new Uint8Array(array), options?.urlSafe);
export const arrayToBase32 = (array) => base32crockford.encode(new Uint8Array(array));
export const arrayToBase16 = (array) => base16.encode(new Uint8Array(array));
export const base64ToArray = (base64Str) => Base64.toUint8Array(base64Str).buffer;
export const base64ToUint8Array = (base64Str) => Base64.toUint8Array(base64Str);
export const stringToBase64 = (str) => arrayToBase64(stringToArray(str));
export const base64ToString = (base64Str) => Base64.decode(base64Str);
export const concatArrays = (buffers) => {
    const bytesCnt = buffers.reduce((acc, curr) => {
        return acc + curr.byteLength;
    }, 0);
    const result = new Uint8Array(bytesCnt);
    let pos = 0;
    for (const buf of buffers) {
        result.set(new Uint8Array(buf), pos);
        pos += buf.byteLength;
    }
    return result.buffer;
};
